import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const fontSans =
  "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const config = defineConfig({
  cssVarsPrefix: 'oq',
  theme: {
    tokens: {
      fonts: {
        body: { value: fontSans },
        heading: { value: fontSans },
      },
      colors: {
        oddsquake: {
          void: { value: '#050b14' },
          panel: { value: '#0b1422' },
          panel2: { value: '#111b2b' },
          line: { value: 'rgba(148, 163, 184, 0.16)' },
          soft: { value: '#91a4bd' },
          bright: { value: '#e7efff' },
          good: { value: '#32d46b' },
          bad: { value: '#ff4d64' },
          warn: { value: '#f6a524' },
          bluefire: { value: '#2f81f7' },
        },
      },
      radii: {
        oqPanel: { value: '0.75rem' },
        oqControl: { value: '0.625rem' },
      },
      shadows: {
        oqPanel: {
          value:
            'inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 18px 70px rgba(0, 0, 0, 0.24)',
        },
        oqBlueGlow: {
          value: '0 0 0 1px rgba(47, 129, 247, 0.06), 0 0 38px rgba(47, 129, 247, 0.07)',
        },
        oqGoodGlow: {
          value: '0 0 0 1px rgba(50, 212, 107, 0.06), 0 0 38px rgba(50, 212, 107, 0.06)',
        },
        oqBadGlow: {
          value: '0 0 0 1px rgba(255, 77, 100, 0.06), 0 0 38px rgba(255, 77, 100, 0.06)',
        },
      },
    },
    semanticTokens: {
      colors: {
        surface: {
          page: { value: '{colors.oddsquake.void}' },
          panel: { value: '{colors.oddsquake.panel}' },
          panelElevated: { value: '{colors.oddsquake.panel2}' },
          control: { value: 'rgba(0, 0, 0, 0.1)' },
          'control.hovered': { value: 'rgba(255, 255, 255, 0.06)' },
          'control.active': { value: 'rgba(255, 255, 255, 0.12)' },
        },
        border: {
          subtle: { value: '{colors.oddsquake.line}' },
          active: { value: '{colors.oddsquake.bluefire}' },
        },
        text: {
          primary: { value: '{colors.oddsquake.bright}' },
          muted: { value: '{colors.oddsquake.soft}' },
        },
        signal: {
          good: { value: '{colors.oddsquake.good}' },
          bad: { value: '{colors.oddsquake.bad}' },
          warn: { value: '{colors.oddsquake.warn}' },
          blue: { value: '{colors.oddsquake.bluefire}' },
        },
        brand: {
          solid: { value: '{colors.oddsquake.bluefire}' },
          subtle: { value: 'rgba(47, 129, 247, 0.12)' },
          emphasized: { value: '{colors.oddsquake.bright}' },
          fg: { value: '#dbeafe' },
        },
      },
      shadows: {
        panel: { value: '{shadows.oqPanel}' },
        glowBlue: { value: '{shadows.oqBlueGlow}' },
        glowGood: { value: '{shadows.oqGoodGlow}' },
        glowBad: { value: '{shadows.oqBadGlow}' },
      },
    },
    layerStyles: {
      glassPanel: {
        value: {
          borderWidth: '1px',
          borderColor: 'border.subtle',
          bg: 'surface.panel',
          boxShadow: 'panel',
          backdropFilter: 'blur(18px)',
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
